import React from 'react';
import { Stack, HStack, VStack, Box, Text } from '@chakra-ui/react';
import Navbar from '../components/navbar';
import { Link } from 'react-router-dom';
const Anchors = () => {
  return (
    <>
      <>
        <Box bg={'#91B8B4'} h={'140vh'}>
          <Navbar />
          <VStack spacing={4} align="stretch" alignItems={'center'}>
            <Box>
              <HStack spacing="24px" mt={'50px'} mb={'10px'}>
                <Text fontSize="60px" color={'#0F2837'}>
                  مرتكزات ترجم
                </Text>
              </HStack>
            </Box>
            <Box mt={'30px !important'}>
              <Box
                border={'1px solid '}
                h={'120px'}
                mb={'30px'}
                textAlign={'center'}
                w="690px"
                bg={'#0F2837'}
                borderRadius={'10px '}
              >
                <Text mt={'30px'} p={'5px'} fontSize="30px" color={'#fff'}>
                  إثراء المحتوى والوصول للمتلقي محلياً وعالمياً
                </Text>
              </Box>
              <Box
                border={'1px solid '}
                h={'120px'}
                mb={'30px'}
                textAlign={'center'}
                w="690px"
                bg={'#0F2837'}
                borderRadius={'10px '}
              >
                <Text mt={'30px'} p={'5px'} fontSize="30px" color={'#fff'}>
                  تطوير منظومة تنافسية مستدامة
                </Text>
              </Box>
              <Box
                border={'1px solid '}
                h={'150px'}
                mb={'30px'}
                textAlign={'center'}
                w="690px"
                bg={'#0F2837'}
                borderRadius={'10px '}
              >
                <Text mt={'30px'} p={'5px'} fontSize="30px" color={'#fff'}>
                  نشر ثقافة القراءة كممارسة أساسية في اكتساب المعرفة
                </Text>
              </Box>
              <Box
                border={'1px solid '}
                h={'120px'}
                mb={'30px'}
                textAlign={'center'}
                w="690px"
                bg={'#0F2837'}
                borderRadius={'10px '}
              >
                <Text mt={'30px'} p={'5px'} fontSize="30px" color={'#fff'}>
                  تعزيز التواصل الفعال مع أصحاب العلاقة
                </Text>
              </Box>
            </Box>
          </VStack>
          <Box>
            <HStack
              spacing="50px"
              justifyContent={'left'}
              mt={'140px'}
              mb={'50px'}
              ml={'50px'}
            >
              <Link to="/">
                <Box
                  textAlign={'center'}
                  w="190px"
                  h="50px"
                  color={'#fff'}
                  bg={'#0F2837'}
                  fontSize={'30px'}
                  borderRadius={'10px'}
                >
                  الرجوع للخلف
                </Box>
              </Link>
            </HStack>
          </Box>
        </Box>
      </>{' '}
    </>
  );
};

export default Anchors;
